<template>
    <div class="n2-center-container">
        <div style="max-width: 600px; margin:0 auto;">
            <signin></signin>
        </div>
    </div>


</template>

<script>
    import { mapGetters } from 'vuex';

    import Signin from '../components/app/signin.vue'

    export default {
        components: {
            Signin
        },
        data: function () {
            return {
                code: ''
            }
        },
        computed: {
            ...mapGetters('globalization', [
                'app_locale',
                'locale'
            ])
        },
        created: function () {
        },
        mounted: async function () {

        },
        methods: {

        }
    }
</script>
